export default __webpack_public_path__ + "static/media/pasta-menu.a33928f2.svg";